import { FC, useEffect, useState } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';
import { cn } from 'utils/helpers';

import PublicWrapper from '../PublicWrapper';
import Form from './Form';
import Success from './Success';

const ChangePassword: FC = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [changedPassword, setChangedPassword] = useState(false);

  useEffect(() => {
    if (!params.get('otp') || !params.get('referenceId')) navigate('/login');
  }, [params, navigate]);

  return (
    <PublicWrapper
      data-aos="fade-up"
      className={cn(
        'h-screen',
        'flex flex-col items-center justify-center',
        'text-sm text-secondary-base',
        'p-3 py-14',
      )}
    >
      {!changedPassword ? (
        <Form changedPassword={setChangedPassword} />
      ) : (
        <Success />
      )}
    </PublicWrapper>
  );
};

export default ChangePassword;
